let fontsRequested = false;

const importFonts = () =>
  Promise.all([
    import('@fontsource/nunito-sans/latin-400.css'),
    import('@fontsource/nunito-sans/latin-500.css'),
    import('@fontsource/nunito-sans/latin-600.css'),
    import('@fontsource/nunito-sans/latin-700.css'),
    import('@fontsource/nunito-sans/latin-800.css')
  ]);

const scheduleFontLoad = () => {
  if (fontsRequested) {
    return;
  }
  fontsRequested = true;

  const startLoading = () => {
    importFonts().catch((error) => {
      if (process.env.NODE_ENV !== 'production') {
        console.warn('Font loading failed', error);
      }
    });
  };

  if (typeof window === 'undefined') {
    return;
  }

  if ('requestIdleCallback' in window) {
    window.requestIdleCallback(startLoading, { timeout: 2000 });
  } else {
    window.setTimeout(startLoading, 1200);
  }
};

exports.scheduleFontLoad = scheduleFontLoad;
